<template>
  <div
    :class="{ 'non-border-top': nonBorderTop }"
    class="lv-file-list"
    :style="{ marginTop: marginTop + 'px' }"
  >
    <LvText v-if="title" :h4="bigTitle" :h5="!bigTitle" bold>
      {{ $t(title) }}
    </LvText>
    <div
      class="lv-file-list__content"
      :class="{ outline, 'lv-file-list__content--full-width': fullWidth }"
    >
      <div
        v-for="(file, fileIndex) in value"
        :key="`file_${fileIndex}`"
        class="lv-file-list__file"
        :class="{ twoItem, threeItem }"
      >
        <LvDownloadFileBtn
          :id="file.id"
          :small="small"
          :url="file.url"
          :module="module"
          :upload="upload"
          :narrow="narrow"
          :num="fileIndex"
          :name="file.name"
          :hasScope="file.hasScope"
          :fileType="file.fileType"
          :chipList="file.chipList"
          :isLoading="file.isLoading"
          :showDeleteBtn="showDeleteBtn"
          :showMoreBtn="file.showMoreBtn"
          :download="download && file.hasScope"
          :showDownloadBtn="file.showDownloadBtn"
          :isClickable="file.isClickable"
          :isImageViewable="_isImageViewable"
          :versionNumber="file.versionNumber"
          @no-scroll="$_noScrollClick()"
          @go-to="$emit('go-to', $event)"
          @scroll-click="$_scrollClick()"
          @remove="$_onDelete(fileIndex)"
          @download-end="$_onDownloadEnd(file)"
        />
      </div>
    </div>
    <div v-if="(!value || !value.length) && noFileText" class="mt-20 ml-20">
      <LvText h4>{{ $t(noFileText) }}</LvText>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    download: {
      type: Boolean,
      default: true,
    },
    nonBorderTop: {
      type: Boolean,
      default: false,
    },
    noFileText: {
      type: String,
    },
    title: {
      type: String,
    },
    bigTitle: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
    },
    twoItem: {
      type: Boolean,
      default: false,
    },
    threeItem: {
      type: Boolean,
      default: false,
    },
    upload: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    showDeleteBtn: {
      type: Boolean,
      default: false,
    },
    module: {
      type: String,
    },
    /** 為 true 時每列於各視窗寬度皆為 100%（一列一個檔案），並讓內層下載按鈕橫向滿版 */
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _isImageViewable() {
      return this.$store.state.app.factory.isImageViewable;
    },
  },
  methods: {
    $_onDelete(index) {
      this.$emit('delete-file', index);
    },
    $_noScrollClick() {
      this.$emit('no-scroll');
    },
    $_scrollClick() {
      this.$emit('scroll-click');
    },
    $_onDownloadEnd(file) {
      this.$emit('download-end', file);
    },
  },
};
</script>
